// A blocked element's `src` is moved to `data-src` and restored on consent.
// When the original element had no source, that move can collapse the missing
// value into the empty string or the stringified `null`/`undefined`. Restoring
// any of them as a real `src` would request <origin>/<that string> (e.g. a
// bogus GET to <origin>/null), so none of them is restorable.
//
export default function isRestorableSrc(src) {
  if ( !src ) {
    return false
  }

  return src !== 'null' && src !== 'undefined'
}
